module.exports = __webpack_public_path__ + "static/media/de.11e29aeb.png";